import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Grid,
  Typography,
  Box,
  useTheme,
  Button,
  Dialog,
  DialogContent,
  Card,
  useMediaQuery,
} from "@mui/material";
import { useHistory } from "react-router-dom";
import SecondaryCenterTemplate from "components/SecondaryCenterTemplate";
import { Field, reduxForm, getFormSyncErrors, getFormValues } from "redux-form";
import { renderTextField } from "components/FormFields/FieldTypes";
import {
  Required,
  emailValidator,
  EmailMatch,
} from "components/FormFields/validators";
import VerificationOTPField from "components/VerificationOTPField";
import { homeActions } from "actions";
import SuccessDialog from "components/SuccessDialog";
import MessageDialog from "pages/SearchMedication/MessageDialog";

const ChangeEmailAddress = (props) => {
  const theme = useTheme();
  const history = useHistory();
  const matchesMinWidth = useMediaQuery("(max-width:600px)");

  const {
    formErrors,
    formValues,
    OTPValues,
    emailChange,
    profileInfo,
    changeEmailInfo,
    verifyEmailChange,
    changeEmailVerify,
    accountResendInfo,
    accountResendAttempt,
    resetAccountChangeData,
    getProfile,
  } = props;
  const { profileData } = profileInfo;

  const [showOtp, setShowOtp] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showResendSuccess, setShowResendSuccess] = useState(false);
  const [showSameEmailDialog, setShowSameEmailDialog] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  useEffect(() => {
    document.getElementById("appcontent").scroll(0, 0);
    if (!profileData?.data) {
      getProfile();
    }
    return () => {
      resetAccountChangeData();
    };
  }, []);

  useEffect(() => {
    if (changeEmailInfo) {
      setShowOtp(true);
    }
  }, [changeEmailInfo]);

  useEffect(() => {
    if (accountResendInfo) {
      setShowResendSuccess(true);
    }
  }, [accountResendInfo]);

  useEffect(() => {
    if (changeEmailVerify && Object.keys(changeEmailVerify).length) {
      setShowSuccess(true);
      setSuccessMsg(changeEmailVerify.message);
    }
  }, [changeEmailVerify]);

  const onOTPFormSubmit = () => {
    const verificationCode =
      OTPValues["one"] +
      OTPValues["two"] +
      OTPValues["three"] +
      OTPValues["four"] +
      OTPValues["five"] +
      OTPValues["six"];
    verifyEmailChange({
      verificationCode: verificationCode,
      profileUpdateAttemptId: changeEmailInfo,
    });
    setShowOtp(false);
  };

  const onFormSubmit = () => {
    if (formValues?.newEmail === profileData?.data?.email) {
      setShowSameEmailDialog(true);
    } else {
      emailChange(formValues.newEmail);
    }
  };

  return (
    <SecondaryCenterTemplate pageTitle="Change Email Address">
      <Grid container>
        <Grid item xs={12} sm={8} sx={{ margin: "auto" }}>
          <form>
            <Grid item container>
              <Grid
                item
                xs={12}
                sm={12}
                p={4}
                pt={0}
                sx={{ textAlign: "center" }}
              >
                {profileData?.data && profileData?.data?.email ? (
                  <Typography
                    variant="text4"
                    sx={{
                      color: theme.palette.common.textGrey2,
                      fontFamily: "Lato-Regular",
                    }}
                  >
                    {" "}
                    Your current email address:
                  </Typography>
                ) : (
                  <Typography variant="h3LatoBlack">
                    {" "}
                    You have not yet added an email address.
                  </Typography>
                )}
                <Box mt={1}>
                  <Typography variant="text2">
                    {profileData?.data && profileData?.data?.email}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={12} p={4} pt={0}>
                <Field
                  name="newEmail"
                  isRequired
                  component={renderTextField}
                  label="Please enter your new email address"
                  validate={[Required, emailValidator, EmailMatch]}
                />
              </Grid>

              <Grid item xs={12} sm={12} p={4} pt={0}>
                <Field
                  name="confirmEmail"
                  isRequired
                  component={renderTextField}
                  label="Please confirm your new email address"
                  validate={[Required, emailValidator, EmailMatch]}
                />
              </Grid>

              <Grid
                item
                xs={12}
                sm={10}
                sx={{ margin: "auto", textAlign: "center" }}
              >
                <Box mt={4}>
                  <Button
                    variant="large"
                    onClick={() => onFormSubmit()}
                    disabled={Object.keys(formErrors).length ? true : false}
                    sx={{
                      wordSpacing: 2,
                      minWidth: "100%",
                      backgroundColor:
                        formErrors && Object.keys(formErrors).length
                          ? "#e6e6e6"
                          : undefined,
                      color:
                        formErrors && Object.keys(formErrors).length
                          ? "#637276"
                          : undefined,
                      boxShadow: "none",
                    }}
                  >
                    CHANGE EMAIL ADDRESS
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
          {showOtp ? (
            <Dialog open={showOtp} className="info-dialog">
              <DialogContent sx={{ padding: "40px" }}>
                <Box mt={2} sx={{ paddingLeft: "8px" }}>
                  <Typography
                    variant="text4"
                    sx={{
                      color: theme.palette.common.textGrey2,
                      fontFamily: "Lato-Regular",
                    }}
                  >
                    A verification code has been sent to:
                  </Typography>
                </Box>
                <Box mt={1} mb={3}>
                  <Typography variant="text2">
                    {formValues && formValues.newEmail}
                  </Typography>
                </Box>
                <Card sx={{ height: 100 }}>
                  <Box
                    mt={2}
                    sx={{
                      textAlign: "left",
                      paddingLeft: {
                        xs: "18px",
                        sm: "18px",
                        md: "23px",
                        lg: "23px",
                        xl: "23px",
                      },
                    }}
                  >
                    <Typography
                      variant="text4"
                      sx={{
                        color: "#003d4c",
                        fontFamily: "Lato-Bold",
                        fontSize: {
                          xs: "0.8rem",
                          sm: "0.8rem",
                          md: "1rem",
                          lg: "1rem",
                        },
                      }}
                    >
                      Please enter the verification code:
                    </Typography>
                  </Box>
                  <VerificationOTPField />
                </Card>
                <Box
                  mt={2}
                  mb={5}
                  component="div"
                  sx={{ textAlign: "left" }}
                  onClick={() => {
                    accountResendAttempt(changeEmailInfo);
                    // setShowResendSuccess(true);
                  }}
                >
                  <Typography
                    variant="h3LatoRegular"
                    component={Button}
                    sx={{
                      fontSize: "1rem",
                      textTransform: "none",
                      textDecoration: "underline",
                      justifyContent: "flex-start",
                      color: "#008a25",
                      minWidth: { xs: "56px", sm: "56px", md: undefined },
                    }}
                  >
                    Resend verification code{" "}
                    {showResendSuccess ? (
                      <span style={{ color: "#083d4c" }}>
                        &nbsp;-Sent&nbsp;
                      </span>
                    ) : (
                      ""
                    )}
                  </Typography>
                </Box>
                <Box mt={5} mb={3}>
                  <Button
                    variant="large"
                    disabled={
                      !OTPValues || Object.keys(OTPValues).length < 6
                        ? true
                        : false
                    }
                    onClick={onOTPFormSubmit}
                    sx={{
                      minWidth: { xs: "56px", sm: "56px", md: "100%" },
                      fontSize: {
                        xs: "14px",
                        sm: "14px",
                        md: "20px",
                        lg: "20px",
                      },
                    }}
                  >
                    CHANGE EMAIL ADDRESS
                  </Button>
                </Box>
                <Box mb={2}>
                  <Button
                    variant="text"
                    onClick={() => setShowOtp(false)}
                    sx={{
                      minWidth: { xs: "56px", sm: "56px", md: undefined },
                      textDecoration: "underline",
                      fontSize: {
                        xs: "14px",
                        sm: "14px",
                        md: "20px",
                        lg: "20px",
                      },
                    }}
                  >
                    CANCEL
                  </Button>
                </Box>
              </DialogContent>
            </Dialog>
          ) : null}
          {showSuccess ? (
            <SuccessDialog
              showSuccessDialog={showSuccess}
              successMsg={successMsg}
              onSuccessClick={() => {
                history.push("/MyAccount/Profile");
                setShowSuccess(false);
              }}
            />
          ) : null}
          <MessageDialog showPopUp={showSameEmailDialog}>
            <Box sx={{ maxWidth: "400px" }}>
              <Typography
                variant={matchesMinWidth ? "h3LatoBold" : "h2LatoBold"}
                sx={{ lineHeight: matchesMinWidth ? "24px" : "26px" }}
              >
                Entered value should be different from your current email.
              </Typography>
            </Box>
            <Box mt={5}>
              <Button
                variant="large"
                onClick={() => {
                  setShowSameEmailDialog(false);
                }}
              >
                DONE
              </Button>
            </Box>
          </MessageDialog>
        </Grid>
      </Grid>
    </SecondaryCenterTemplate>
  );
};

const mapStateToProps = (state) => {
  return {
    formErrors: getFormSyncErrors("CHANGE_EMAIL_FORM")(state) || {},
    formValues: getFormValues("CHANGE_EMAIL_FORM")(state),
    OTPValues: getFormValues("OTP_FIELD")(state),
    profileInfo: state.profile,
    changeEmailInfo: state.changeEmail.data,
    accountResendInfo: state.accountResendInfo.data,
    changeEmailVerify: state.changeEmailVerify.data,
  };
};

const mapDispatchToProps = {
  getProfile: () => homeActions.getProfile(),
  emailChange: (params) => homeActions.emailChange(params),
  verifyEmailChange: (params) => homeActions.verifyEmailChange(params),
  accountResendAttempt: (params) => homeActions.accountResendAttempt(params),
  resetAccountChangeData: () => homeActions.resetAccountChangeData(),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: "CHANGE_EMAIL_FORM",
  })(ChangeEmailAddress)
);
